/*
Create a global 'syrinscape' object.
*/

import config from 'modules-core/config'
import log from 'modules-core/log'

declare global {
	interface Window {
		syrinscape: any
		Sentry: any
	}
}

window.syrinscape ??= { config, log }

export const syrinscape = window.syrinscape
export default syrinscape
